import { IconButton, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import SearchIcon from '@material-ui/icons/Search';
import { useSnackbar } from 'notistack';
import React, { useContext, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import Pin from '../../../images/icons/pin.svg';
import Star from '../../../images/icons/star.svg';
import PDF from '../../../images/icons/pdf-file.svg';
import AVI from '../../../images/icons/avi-file.svg';
import DOC from '../../../images/icons/doc-file.svg';
import JPG from '../../../images/icons/jpg-file.svg';
import PNG from '../../../images/icons/png-file.svg';
import PPT from '../../../images/icons/ppt-file.svg';
import WAV from '../../../images/icons/wav-file.svg';
import XLS from '../../../images/icons/xls-file.svg';
import { AppContext } from '../../shared/context';
import TipoPerfil from '../../../constants/tipoPerfil';

import {
  desafixarDeReunicao,
  desfavoritar,
  download,
  excluir,
  favoritar,
  fixarEmReunicao,
  getLastDate,
  getPage,
  getSize,
  getTipos,
  getUltimosAcessados,
} from '../../../services/documento/DocumentoService';
import CadastrarDocumento from '../cadastrar';
import CompartilharDocumento from '../compartilhar';
import ExcluirDocumento from '../excluir';
import RenomearDocumento from '../renomear';
import UltimosDocumentosAcessados from '../ultimosAcessados';
import useStyles from './styles';
import BotaoDownload from '../botaoDownload';
import Pagination from "../../shared/pagination";

const tableStyles = makeStyles({
  cabecalho: {
    fontSize: 16,
    fontWeight: 500,
    color: '#5e6784',
  },
  body: {
    fontSize: 16,
    lineHeight: 1.38,
    color: '#061243',
  },
  bodyDetalhe: {
    fontSize: '12px',
    color: '#5e6784',
  },
});

const ListagemBiblioteca = (props) => {
  const { modalOpen, setModalOpen } = props;
  const tableClasses = tableStyles();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [tipos, setTipos] = useState([]);
  const [registros, setRegistros] = useState([]);
  // const [modalOpen, setModalOpen] = useState(false);
  const [openCompartilhar, setOpenCompartilhar] = useState(false);
  const [openRenomear, setOpenRenomear] = useState(false);
  const [openExcluir, setOpenExcluir] = useState(false);
  const [documentoSelecionado, setDocumentoSelecionado] = useState({});
  const [index, setIndex] = useState(null);
  const [ultimosAcessados, setUltimosAcessados] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const isMenuOpen = Boolean(anchorEl);
  const initialState = {
    busca: '',
    idTipo: '',
    formato: '',
    ordenacao: '',
  };

  const [filtro, setFiltro] = useState(initialState);
  const [paginacao, setPaginacao] = useState({ pagina: 0, totalDePaginas: 0 });

  const { role } = useContext(AppContext);

  const handleProfileMenuOpen = (event, registro, index) => {
    setDocumentoSelecionado(registro)
    setIndex(index)
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setDocumentoSelecionado({})
    setIndex(null)
    setAnchorEl(null);
  };

  const handleFixarEmReunicao = async () => {
    try {
      const { id } = documentoSelecionado;
      await fixarEmReunicao(id);
      updateTableRow('fixadoEmReuniao', true);
    } catch (e) {
      enqueueSnackbar('Ocorreu um erro ao favoritar o documento', { variant: 'error' })
    }
  }

  const handleFavoritar = async () => {
    try {
      const { id } = documentoSelecionado;
      await favoritar(id);
      updateTableRow('favorito', true);
    } catch (e) {
      enqueueSnackbar('Ocorreu um erro ao favoritar o documento', { variant: 'error' })
    }
  }

  const handleDesafixarDeReunicao = async () => {
    try {
      const { id } = documentoSelecionado;
      await desafixarDeReunicao(id);
      updateTableRow('fixadoEmReuniao', false);
    } catch (e) {
      enqueueSnackbar('Ocorreu um erro ao favoritar o documento', { variant: 'error' })
    }
  }

  const handleDesfavoritar = async () => {
    try {
      const { id } = documentoSelecionado;
      await desfavoritar(id);
      updateTableRow('favorito', false);
    } catch (e) {
      enqueueSnackbar('Ocorreu um erro ao favoritar o documento', { variant: 'error' })
    }
  }

  const updateTableRow = (atributo, status) => {
    const newRegistros = [...registros];
    const registro = newRegistros[index];
    registro[atributo] = status;
    newRegistros[index] = registro;
    setRegistros(newRegistros)
  }

  const handleExcluir = async () => {
    try {
      const { id } = documentoSelecionado;
      await excluir(id);
      enqueueSnackbar('Documento excluído com sucesso', { variant: 'success' })
    } catch (e) {
      enqueueSnackbar('Erro ao excluir', { variant: 'error' })
    }
  }

  const getRegistros = async (page, ordenacao = '', filter = filtro) => {
    try {
      if (!ordenacao) {
        ordenacao = 'criacao';
      }
      const response = await getPage(page, ordenacao, filter);
      const { data } = response;
      const { content, totalPages } = data;
      setRegistros(content);
      setPaginacao({ pagina: page, totalDePaginas: totalPages })
      getUltimosDocumentosAcessados();
    } catch (e) {

    }
  }

  useEffect(() => {
    getTipos().then((response) => {
      if (response && response.status === 200) {
        const { data } = response;
        setTipos(data)
      }
    })
    const { pagina } = paginacao;
    const { ordenacao } = filtro;
    getRegistros(pagina, ordenacao);
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFiltro({ ...filtro, [name]: value })
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const { pagina } = paginacao;
    const { ordenacao } = filtro;
    getRegistros(pagina, ordenacao);
  }

  const limparFiltros = () => {
    const pagina = 0;
    const { ordenacao } = initialState;
    setFiltro(initialState);
    getRegistros(pagina, ordenacao, initialState);
    handleMenuClose();
  }

  const getUltimosDocumentosAcessados = async () => {
    try {
      const response = await getUltimosAcessados();
      const { data } = response;
      setUltimosAcessados(data);
    } catch (e) {

    }
  }

  const handleDownload = async (documentoSelecionado) => {
    const { id, nome, formato } = documentoSelecionado;
    try {
      const response = await download(id);
      const url = URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      document.body.appendChild(a);
      a.download = `${nome}.${formato}`;
      a.click();
      getUltimosDocumentosAcessados();
    } catch (e) {
      enqueueSnackbar('Ocorreu um erro ao realizar o download', { variant: 'error' })
    }
  }

  const acoes = () => {
    const { fixadoEmReuniao, favorito } = documentoSelecionado;

    return (
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        keepMounted
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={() => setOpenCompartilhar(true)}>Compartilhar</MenuItem>

        {TipoPerfil.EQUIPE_TECNICA.is(role) ? (
          fixadoEmReuniao ? (
            <MenuItem onClick={handleDesafixarDeReunicao}>Desafixar de reuniões</MenuItem>
          ) : (
            <MenuItem onClick={handleFixarEmReunicao}>Fixar em reuniões</MenuItem>
          )
        ) : null}

        {favorito ? <MenuItem onClick={handleDesfavoritar}> Remover dos favoritos</MenuItem>
          : <MenuItem onClick={handleFavoritar}> Adicionar aos favoritos</MenuItem>}

        {TipoPerfil.EQUIPE_TECNICA.is(role) && <MenuItem onClick={() => setOpenRenomear(true)}>Renomear</MenuItem>}
        {TipoPerfil.EQUIPE_TECNICA.is(role) && <MenuItem onClick={() => setOpenExcluir(true)}>Excluir</MenuItem>}

      </Menu>
    )
  };

  const getFileIcon = (formato) => {
    if (formato === 'pdf') {
      return PDF;
    }

    if (formato === 'avi') {
      return AVI;
    }

    if (formato === 'doc' || formato === 'docx') {
      return DOC;
    }

    if (formato === 'jpg' || formato === 'jpeg') {
      return JPG;
    }

    if (formato === 'png') {
      return PNG;
    }

    if (formato === 'ppt' || formato === 'pptx') {
      return PPT
    }

    if (formato === 'wav') {
      return WAV
    }

    if (formato === 'xls') {
      return XLS
    }
  }
  const {
    busca, idTipo, formato, ordenacao,
  } = filtro;
  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className={classes.barraFiltroDiv}>
          <div className={classes.barraFiltro}>
            <Grid container spacing={1}>
              <Grid item md={2} sm={12} xs={12}>
                <TextField
                  id="busca"
                  name="busca"
                  fullWidth
                  variant="outlined"
                  value={busca}
                  onChange={handleChange}
                  placeholder="Digite sua busca"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon style={{ color: '#0B4FD9', cursor: 'pointer' }} />
                      </InputAdornment>
                    ),
                    endAdornment: (busca
                      ? (
                        <InputAdornment onClick={() => setFiltro({ ...filtro, busca: '' })} position="start">
                          <CloseIcon style={{ color: '#5e6784', cursor: 'pointer' }} />
                        </InputAdornment>
                      ) : <></>
                    ),
                  }}
                />
              </Grid>
              <Grid item md={2} sm={4} xs={6}>
                <Select
                  id="idTipo"
                  name="idTipo"
                  value={idTipo}
                  onChange={handleChange}
                  fullWidth
                  displayEmpty
                  variant="outlined"
                  IconComponent={ExpandMoreIcon}
                >
                  <MenuItem value="" disabled>
                    <span style={{ color: '#5e6784' }}>Tipo</span>
                  </MenuItem>
                  {tipos.map((tipo) => (
                    <MenuItem
                      key={tipo.id}
                      value={tipo.id}
                    >
                      {tipo.descricao}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              <Grid item md={2} sm={4} xs={6}>
                <Select
                  id="formato"
                  name="formato"
                  value={formato}
                  onChange={handleChange}
                  fullWidth
                  displayEmpty
                  variant="outlined"
                  IconComponent={ExpandMoreIcon}
                >
                  <MenuItem value="" disabled>
                    <span style={{ color: '#5e6784' }}>Formato</span>
                  </MenuItem>
                  <MenuItem value="documento">Documento DOC</MenuItem>
                  <MenuItem value="apresentacao">Apresentação PPT</MenuItem>
                  <MenuItem value="docPDF">Documento PDF</MenuItem>
                  <MenuItem value="planilha">Planilha XLS</MenuItem>
                  <MenuItem value="imagem">Imagem</MenuItem>
                  <MenuItem value="video">Vídeo</MenuItem>
                </Select>
              </Grid>
              <Grid item md={2} sm={4} xs={6}>
                <Select
                  id="ordenacao"
                  name="ordenacao"
                  value={ordenacao}
                  onChange={handleChange}
                  fullWidth
                  displayEmpty
                  variant="outlined"
                  IconComponent={ExpandMoreIcon}
                >
                  <MenuItem value="" disabled>
                    <span style={{ color: '#5e6784' }}>Ordernar</span>
                  </MenuItem>
                  <MenuItem value="criacao">Por Data de Adição</MenuItem>
                  <MenuItem value="favorito">Favoritos Primeiro</MenuItem>
                  <MenuItem value="fixadoEmReuniao">Fixados Primeiro</MenuItem>
                </Select>
              </Grid>

              <Grid item md={2} sm={4} xs={6}>
                <Button
                  type="submit"
                  variant="contained"
                >
                  Aplicar filtro
                </Button>
              </Grid>

              <Grid item md={2} sm={4} xs={6}>
                <Button
                  onClick={() => limparFiltros()}
                  variant="outlined"
                >
                  Limpar
                  filtros
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>

      </form>


      <div style={{ margin: '24px 24px' }}>
        <UltimosDocumentosAcessados documentos={ultimosAcessados} />
        {registros.length > 0
          && (
            <div style={{ padding: 20 }}>
              <div style={{ padding: 10 }}>
                <Grid container spacing={4}>
                  <Grid item md={2}>
                    <Typography className={tableClasses.cabecalho}>Nome</Typography>
                  </Grid>
                  <Grid item md={2}>
                    <Typography className={tableClasses.cabecalho}>Tipo</Typography>
                  </Grid>
                  <Grid item md={2}>
                    <Typography className={tableClasses.cabecalho}>Tamanho</Typography>
                  </Grid>
                  <Grid item md={4}>
                    <Typography className={tableClasses.cabecalho} />
                  </Grid>
                  <Grid item md={1}>
                    <Typography className={tableClasses.cabecalho} />
                  </Grid>
                  <Grid item md={1}>
                    <Typography className={tableClasses.cabecalho} />
                  </Grid>
                </Grid>
              </div>
              <div style={{
                backgroundColor: '#fff', borderRadius: 6, border: 'solid 1px #dfdfe6', padding: 10,
              }}
              >
                <Grid container spacing={4}>
                  {registros.map((registro, index) => (
                    <>
                      <Grid key={`nome_${index}`} item md={2} style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ width: 18, height: 20 }}>
                          <img src={getFileIcon(registro.formato)} />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <Typography className={tableClasses.body}>{registro.nome}</Typography>
                          <Typography className={tableClasses.bodyDetalhe}>
                            Adicionado
                          {getLastDate(registro.dataUltimoAcesso)}
                            {' '}
                          -
                          {registro.formato}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid key={`tipo_${index}`} item md={2} style={{ display: 'flex', alignItems: 'center' }}>
                        <Typography className={tableClasses.body}>{registro.descricaoTipo}</Typography>
                      </Grid>
                      <Grid key={`tamanho_${index}`} item md={2} style={{ display: 'flex', alignItems: 'center' }}>
                        <Typography className={tableClasses.body}>{getSize(registro.tamanho)}</Typography>
                      </Grid>
                      <Grid
                        key={`pin_${index}`}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                        item
                        md={3}
                      >
                        {registro.fixadoEmReuniao
                          && (
                            <div>
                              <img src={Pin} />
                              {' '}
                          Fixado em Reunião
                            </div>
                          )}

                        {registro.favorito
                          && (
                            <div>
                              <img src={Star} />
                              {' '}
                          Favoritos
                            </div>
                          )}
                      </Grid>
                      <Grid key={`download_${index}`} style={{ display: 'flex', justifyContent: 'center' }} item md={2}>
                        <BotaoDownload onClickHandle={() => handleDownload(registro)} />
                      </Grid>
                      <Grid key={`acoes_${index}`} style={{ display: 'flex', justifyContent: 'center' }} item md={1}>
                        <IconButton onClick={(event) => handleProfileMenuOpen(event, registro, index)}>
                          <MoreVertIcon />
                        </IconButton>
                      </Grid>
                      {index !== registros.length - 1
                        && (
                          <Grid key={`hr_${index}`} style={{ margin: 0, padding: '0 10px' }} item xs={12}>
                            <hr style={{ border: '0.5px solid #dfdfe6' }} />
                          </Grid>
                        )}
                    </>
                  ))}
                </Grid>
              </div>
            </div>
          )}
        {acoes()}
        {paginacao.totalDePaginas > 1 && <Pagination
          pagina={paginacao.pagina}
          tamanhoDaPagina={8}
          totalDePaginas={paginacao.totalDePaginas}
          onChangePage={getRegistros}
        />}

      </div>
      {modalOpen && (
        <CadastrarDocumento
          afterSubmit={limparFiltros}
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          tipos={tipos}
        />
      )}
      {openCompartilhar && (
        <CompartilharDocumento
          open={openCompartilhar}
          documento={documentoSelecionado}
          onClose={() => setOpenCompartilhar(false)}
        />
      )}
      {openRenomear
        && (
          <RenomearDocumento
            afterSubmit={limparFiltros}
            open={openRenomear}
            onClose={() => setOpenRenomear(false)}
            idDocumento={documentoSelecionado.id}
          />
        )}
      {openExcluir
        && (
          <ExcluirDocumento
            afterSubmit={limparFiltros}
            open={openExcluir}
            onClose={() => setOpenExcluir(false)}
            documento={documentoSelecionado}
            onExcluir={handleExcluir}
          />
        )}
    </>
  )
};

export default ListagemBiblioteca;
